export default __webpack_public_path__ + "static/media/bets.47d629a3.png";